// extracted by mini-css-extract-plugin
export default {"wrapper":"q3-z","play":"r3-z"};